<template>
  <div>
    <a-modal
      width="540px"
      title="需求作废"
      :visible="visible"
      :ok-button-props="{ props: { loading: loading } }"
      @cancel="onClose"
      @ok="onOk"
    >
      <a-form-model ref="form" :form="formData" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }" :rules="rules" :model="formData">
        <a-row :gutter="24">
          <a-form-model-item label="作废原因" prop="reason">
            <a-select v-model="formData.reason" allow-clear placeholder="请选择作废原因">
              <a-select-option v-for="(item, idx) in invalidReason" :key="idx" :value="item.value">{{ item.label }} </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-row>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { invalidBusinessRequirement } from '@/api/business/requirement';
import { invalidReason } from '@/utils/dictionary';

export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      invalidReason,
      visible: false,
      loading: false,
      formData: {
        reason: '',
        id: 0
      },
      rules: {
        reason: [{ required: true, message: '请选择作废原因', trigger: 'blur' }]
      }
    };
  },
  computed: {
  },
  methods: {
    onOpen() {
      this.visible = true;
    },

    onClose() {
      this.visible = false;
      this.formData = {
        reason: '',
        id: 0
      };
    },
    onOk() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          invalidBusinessRequirement({ id: this.dataSource.id, reason: this.formData.reason }).then(() => {
            this.$emit('saveOk');
            this.$message.success('已作废成功，请关闭页面');
            this.onClose();
            this.loading = false;
          })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: 8px;
  display: flex;

  .ant-form-item-control-wrapper {
    flex: 1;
  }
}

.filter-data {
  margin-top: 16px;
}
</style>
